import { keyframes } from '@emotion/react';

export const achievementUnlockRingExpand = keyframes`
    0% {
        transform: scale(0.7);
        opacity: 0.9;
        border-width: 3px;
    }
    100% {
        transform: scale(1.9);
        opacity: 0;
        border-width: 1px;
    }
`;

export const achievementUnlockReveal = keyframes`
    0% {
        opacity: 0;
        transform: translateY(10px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const achievementUnlockFadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;
